<template>
  <fragment>
    <v-container fluid :class="backgroundColor">
      <v-container class="my-10">
        <v-row align="center">
          <v-col cols="12" sm="8" :class="$vuetify.breakpoint.smAndDown ? 'mb-6' : ''">
            <span :class="$vuetify.breakpoint.smAndDown ? `display-1 font-weight-${fontWeight} white--text` : `display-2 font-weight-${fontWeight} white--text`">
              {{ $t(`${title}`) }}
            </span>
          </v-col>
          <v-col cols="12" sm="4" style="text-align: center;">
            <v-btn class="white" x-large rounded @click="$router.push(`${buttonLink}`)" min-width="148">
              {{ $t(`${buttonText}`) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </fragment>
</template>

<script>
export default {
  name: 'informationStrip',
  props: {
    title: String,
    buttonText: String,
    buttonLink: String,
    fontWeight: {
      type: String,
      default: 'light',
    },
    backgroundColor: {
      type: String,
      default: 'sixth',
    },
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
